module.exports = __webpack_public_path__ + "static/media/gcdef_10058.6475c8fc.ico";